import { render, staticRenderFns } from "./Xzzx.vue?vue&type=template&id=38faf22a&scoped=true"
import script from "./Xzzx.vue?vue&type=script&lang=js"
export * from "./Xzzx.vue?vue&type=script&lang=js"
import style0 from "./Xzzx.vue?vue&type=style&index=0&id=38faf22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38faf22a",
  null
  
)

export default component.exports